import { type Device } from '../../../common/types';
import { Link } from 'react-router-dom';

interface IProps {
  item: Device;
  actions: any[];
}

const ListDeviceItem: React.FC<IProps> = ({ item, actions }) => {
  return (
    <tr className="odd:bg-white even:bg-gray-50" key={item.id}>
      <td className="p-2 pl-8 text-sm text-gray-700 items-center">{item.name}</td>
      <td className="p-2 text-sm text-gray-700 items-center">{item.email.toLowerCase()}</td>
      <td className="p-2 text-sm text-gray-700 items-center">{item.description}</td>
      <td className="p-2 text-sm text-gray-700">
        <div className="flex flex-row justify-center space-x-4">
          {actions.map((action, index) => {
            if (action.type === 'link') {
              return (
                <Link to={action.link} key={index}>
                  <span className="px-1 h-full">{action.icon}</span>
                </Link>
              );
            } else if (action.type === 'component') {
              return <div key={index}>{action.icon}</div>;
            } else {
              return (
                <button
                  key={index}
                  onClick={action.handler}
                  className="py-1 px-2 text-gray-50 text-sm text-center rounded-md"
                >
                  <span className="px-1 h-full">{action.icon}</span>
                </button>
              );
            }
          })}
        </div>
      </td>
    </tr>
  );
};

export default ListDeviceItem;
